import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import {
  authorizationExpiryState,
  readAuthorizations,
} from "./insuranceAuthorizationStatus";

export default function InsuranceSection({ setFieldValue, insuranceDetails }) {
  const [formData, setFormData] = useState({});
  const { settings } = useSelector((state) => state.gym.gym);

  const handleRadioChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleTextChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  useEffect(() => {
    if (
      !Object.keys(formData).length &&
      insuranceDetails &&
      Object.keys(insuranceDetails).length
    ) {
      return;
    }
    setFieldValue("insuranceDetails", formData);
  }, [formData, insuranceDetails, setFieldValue]);
  useEffect(() => {
    if (insuranceDetails && Object.keys(insuranceDetails).length > 0) {
      setFormData((prev) => {
        const saved = readAuthorizations(insuranceDetails);
        const pending = (Array.isArray(prev.authorizations)
          ? prev.authorizations
          : []
        ).filter((item) => !item?.authorizationNumber && !item?.expiryDate);
        const next = {
          ...insuranceDetails,
          authorizations: [...saved, ...pending],
        };
        return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
      });
    }
  }, [insuranceDetails]);

  const authorizations = Array.isArray(formData.authorizations)
    ? formData.authorizations
    : [];

  const updateAuthorizations = (nextAuthorizations) => {
    setFormData((prev) => ({
      ...prev,
      authorizations: nextAuthorizations,
    }));
  };

  const updateAuthorization = (index, key, value) => {
    updateAuthorizations(
      authorizations.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [key]: value } : item
      )
    );
  };

  const addAuthorization = () => {
    updateAuthorizations([
      ...authorizations,
      { authorizationNumber: "", expiryDate: "" },
    ]);
  };

  const removeAuthorization = (index) => {
    updateAuthorizations(
      authorizations.filter((_, itemIndex) => itemIndex !== index)
    );
  };
  return (
    <div className="mt-3">
      {settings?.memberRegistration?.fields?.insuranceDetails?.enabled && (
        <Row
          key={"hasInsurance"}
          className="g-3 mb-3 align-items-center pl-2"
          style={{ height: "50px" }}
        >
          <Col md={3}>
            <Label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
              Has Insurance?
            </Label>
          </Col>

          <Col md={2}>
            <div className="d-flex gap-3">
              <FormGroup check className="mb-0 mr-3">
                <Input
                  type="radio"
                  name={"hasInsurance"}
                  value="yes"
                  id={`${"hasInsurance"}-yes`}
                  checked={formData["hasInsurance"] === "yes"}
                  onChange={(e) =>
                    handleRadioChange("hasInsurance", e.target.value)
                  }
                  className="mr-1"
                />
                <Label check htmlFor={`${"hasInsurance"}-yes`}>
                  Yes
                </Label>
              </FormGroup>

              <FormGroup check className="mb-0">
                <Input
                  type="radio"
                  name={"hasInsurance"}
                  value="no"
                  id={`${"hasInsurance"}-no`}
                  checked={formData["hasInsurance"] === "no"}
                  onChange={(e) =>
                    handleRadioChange("hasInsurance", e.target.value)
                  }
                />
                <Label check htmlFor={`${"hasInsurance"}-no`}>
                  No
                </Label>
              </FormGroup>
            </div>
          </Col>
        </Row>
      )}
      {formData?.hasInsurance === "yes" && (
        <>
          <Row className="g-3 mt-3 pt-3 ">
            {settings?.memberRegistration?.fields?.insuranceDetails?.fields
              ?.cardNumber?.enabled && (
              <Col key={"insuranceCardNumber"} md={12}>
                <FormGroup className="custom-inputs mb-3">
                  <Input
                    type="text"
                    value={formData["insuranceCardNumber"]}
                    onChange={(e) =>
                      handleTextChange("insuranceCardNumber", e.target.value)
                    }
                    placeholder={"Card Number"}
                    className="form-control"
                  />
                  <Label>{"Card Number"}</Label>
                </FormGroup>
              </Col>
            )}
            {settings?.memberRegistration?.fields?.insuranceDetails?.fields
              ?.insuranceCompany?.enabled && (
              <Col key={"insuranceCompany"} md={12}>
                <FormGroup className="custom-inputs mb-3">
                  <Label className="fw-semibold mb-2">Insurance Company</Label>
                  <Input
                    type="select"
                    value={formData["insuranceCompany"]}
                    onChange={(e) =>
                      handleTextChange("insuranceCompany", e.target.value)
                    }
                    className="form-control"
                  >
                    <option value="">Select Insurance Company</option>
                    {settings?.memberRegistration?.fields?.insuranceDetails?.insuranceCompanyList.map(
                      (option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      )
                    )}
                  </Input>
                </FormGroup>
              </Col>
            )}
            {settings?.memberRegistration?.fields?.insuranceDetails?.fields
              ?.Copayment?.enabled && (
              <Col key={"Copayment"} md={12}>
                <FormGroup className="custom-inputs mb-3">
                  <Label className="fw-semibold mb-2">Insurance Company</Label>
                  <Input
                    type="select"
                    value={formData["Copayment"]}
                    onChange={(e) =>
                      handleTextChange("Copayment", e.target.value)
                    }
                    className="form-control"
                  >
                    <option value="">Select Insurance Copayment</option>
                    {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50].map(
                      (option) => (
                        <option key={option} value={option}>
                          {option}%
                        </option>
                      )
                    )}
                  </Input>
                </FormGroup>
              </Col>
            )}
            <Col md={12}>
              <div className="insurance-authorizations mb-3">
                <Label className="fw-semibold mb-1">Authorizations</Label>
                <p className="mb-2" style={{ fontSize: "12px", color: "#6b7280" }}>
                  This card can have more than one authorization. If one expires,
                  add another authorization number with a new expiry date.
                </p>
                {authorizations.map((authorization, index) => {
                  const expiryState = authorizationExpiryState(authorization);
                  const expiryLabel =
                    expiryState === "expired"
                      ? "Expired"
                      : expiryState === "valid"
                      ? "Valid"
                      : "No expiry";
                  return (
                    <Row
                      key={`authorization-${index}`}
                      className="g-2 align-items-end mb-2"
                    >
                      <Col md={5}>
                        <FormGroup className="mb-0">
                          <Label style={{ fontSize: "12px" }}>
                            Authorization number
                          </Label>
                          <Input
                            type="text"
                            value={authorization.authorizationNumber || ""}
                            onChange={(e) =>
                              updateAuthorization(
                                index,
                                "authorizationNumber",
                                e.target.value
                              )
                            }
                            placeholder="Authorization number"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup className="mb-0">
                          <Label style={{ fontSize: "12px" }}>Expiry date</Label>
                          <Input
                            type="date"
                            value={authorization.expiryDate || ""}
                            onChange={(e) =>
                              updateAuthorization(
                                index,
                                "expiryDate",
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} className="d-flex align-items-center">
                        <span
                          className={`insurance-authorization-state insurance-authorization-state--${expiryState}`}
                        >
                          {expiryLabel}
                        </span>
                        <Button
                          type="button"
                          color="link"
                          className="text-danger p-0 ml-2"
                          onClick={() => removeAuthorization(index)}
                        >
                          Remove
                        </Button>
                      </Col>
                    </Row>
                  );
                })}
                <Button
                  type="button"
                  color="primary"
                  outline
                  size="sm"
                  onClick={addAuthorization}
                >
                  Add authorization
                </Button>
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}
